import { useOutletContext } from "react-router-dom";
import Dashboard from "../../components/Dashboard";

const DashboardPage = () => {
  const { agent, sessions } = useOutletContext();

  return (
    <div className="h-full overflow-y-auto p-6">
      <Dashboard sessions={sessions} agent={agent} />
    </div>
  );
};

export default DashboardPage;
